import { render, staticRenderFns } from "./SurveyManagementNewAttribute.vue?vue&type=template&id=3fdb6bca&scoped=true&"
import script from "./SurveyManagementNewAttribute.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementNewAttribute.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementNewAttribute.vue?vue&type=style&index=0&id=3fdb6bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb6bca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fdb6bca')) {
      api.createRecord('3fdb6bca', component.options)
    } else {
      api.reload('3fdb6bca', component.options)
    }
    module.hot.accept("./SurveyManagementNewAttribute.vue?vue&type=template&id=3fdb6bca&scoped=true&", function () {
      api.rerender('3fdb6bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementNewAttribute.vue"
export default component.exports